module.exports = __webpack_public_path__ + "static/media/rate.c42a60d2.svg";